/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
  baseStyle: {
    '--tooltip-bg': 'colors.blue.800',
    'px': 2,
    'py': 2,
    'bg': 'var(--tooltip-bg)',
    '--popper-arrow-bg': 'var(--tooltip-bg)',
    'color': 'whiteAlpha.900',
    'borderRadius': 'base',
    'maxW': '280px',
    'lineHeight': '1.5em',
  },
};
